export const tripArrival = (trip) => {
  if (trip.arrivedAt) return trip.arrivedAt;
  if (trip.direction !== 'OUTBOUND') return trip.gateIn || '';
  const client = (trip.checkpoints || []).filter((c) => c.type === 'CLIENT').slice(-1)[0];
  const reached = client && (trip.detections || []).filter((d) => d.checkpointId === client.id && !d.deviation).slice(-1)[0];
  return reached?.detectedAt || (trip.closureReason === 'DESTINATION_REACHED' ? trip.closedAt : '') || '';
};

export const arrivalSummary = (trip, maxAgeMs = 300000, now = Date.now()) => {
  const arrived = tripArrival(trip);
  if (arrived) return { label: 'Arrived (ATA)', at: arrived, severity: 'info' };
  if (trip.closedAt) return { label: 'Trip closed', severity: 'info' };
  if (trip.direction === 'OUTBOUND' && !trip.gateOut) return { label: 'ETA available after departure', severity: 'info' };
  const gps = Date.parse(trip.etaGpsAt);
  if (trip.etaBasis?.includes('distance') && (!Number.isFinite(gps) || gps > now || now - gps > maxAgeMs)) {
    return { label: 'ETA unavailable', note: 'GPS used for the estimate is stale. Waiting for an update.', severity: 'warning' };
  }
  const expected = Date.parse(trip.etaAt);
  if (!Number.isFinite(expected)) return { label: 'ETA unavailable', note: trip.etaReason || 'Waiting for fresh GPS or usable route history.', severity: 'info' };
  return {
    label: expected <= now ? 'Arrival overdue since' : 'Expected arrival (ETA)',
    at: trip.etaAt,
    severity: expected <= now ? 'warning' : 'info',
    note: [`Estimated from ${trip.etaBasis || 'available trip data'}`, trip.etaReason].filter(Boolean).join(' · '),
  };
};
